module.exports = __webpack_public_path__ + "img/ic_hmd@3x.a9ecca5a.png";